<template>
  <div class="container">
    <div
      v-for="(content, index) in infoWindowContents"
      :key="index"
      class="content"
    >
      <div
        v-if="content.title"
        class="infoWindowHeader"
      >
        <InfoWindowName
          :info-window-name="content.title"
          data-testid="title"
        />
      </div>
      <div class="infoWindowBody">
        <DisplayFields :display-fields="content.displayFields" />
        <div v-if="content.comps">
          <div class="comp-window-spacer" />
          <CompGroups
            :comps="content.comps"
            data-testid="compGroups"
            :info-window-content="content"
          />
        </div>
        <div v-if="content.host?.addToOverlay">
          <np-action-btn
            :disabled="!selectedOverlay"
            data-testid="add-to-overlay-button"
            class="float-right mt-2"
            @click="addToOverlay(content)"
          >
            Add to Overlay
          </np-action-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState, mapMutations} from 'vuex';

import InfoWindowName from './sections/Header/InfoWindowName.vue';
import DisplayFields from './DisplayFields/DisplayFields.vue';
import CompGroups from './DisplayFields/Comps/CompGroups.vue';

export default {
  name: 'VectorTileInfoWindow',
  components: {
    InfoWindowName,
    DisplayFields,
    CompGroups,
  },
  props: {
    infoWindowContents: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapState(['selectedOverlay']),
  },
  methods: {
    ...mapMutations(['setSelectedMenuItem']),
    ...mapMutations('infowindow', ['clearInfoWindowContents']),
    async addToOverlay(content) {
      await content.host.addToOverlay(this.selectedOverlay);
      // Unhighlight the parcel after it has been added to the overlay.
      content.host.setHighlight(false);
      // If we succeeded, close the InfoWindow and show the overlay.
      this.clearInfoWindowContents();
      this.setSelectedMenuItem('overlays');
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
</style>
